import { FormControl, FormGroup } from "@angular/forms";
import { ValueUtils } from "../../../../../../../core/service/value-utils/value-utils.service";
import { FundPerformanceFormGroup } from "./fp-form-pojo";
import { FundPerformance } from "src/app/domain/fund-performance/dto/FundPerformance";

export class FpFormService {

  static fillFpForm(fp: FundPerformance): FundPerformanceFormGroup {
    const form = new FormGroup({
      id: new FormControl<number>(fp.id),
      uuid: new FormControl<string>(fp.uuid),
      fundUuid: new FormControl<string>(fp.fundUuid),
      period: new FormControl<Date>(fp.period),
      comment: new FormControl<string>(fp.comment),
      totalCommitment: new FormControl<number>(fp.totalCommitment),
      contribution: new FormControl<number>(fp.contribution),
      realizedGain: new FormControl<number>(fp.realizedGain),
      distribution: new FormControl<number>(fp.distribution),
      carryDistribution: new FormControl<number>(fp.carryDistribution),
      escrow: new FormControl<number>(fp.escrow),
      totalCost: new FormControl<number>(fp.totalCost),
      totalFmv: new FormControl<number>(fp.totalFmv),
      activeCost: new FormControl<number>(fp.activeCost),
      activeFmv: new FormControl<number>(fp.activeFmv),
      realizedCost: new FormControl<number>(fp.realizedCost),
      realizedFmv: new FormControl<number>(fp.realizedFmv),
      unrealized: new FormControl<number>(fp.unrealized),
      netIrr: new FormControl<number>(fp.netIrr === null ? null : Number((fp.netIrr * 100).toFixed(4))),
      carryInterest: new FormControl<number>(fp.carryInterest),
      carryInterestPercent: new FormControl<number>(fp.carryInterestPercent),
      unrealizedCarry: new FormControl<number>({ value: Math.abs(Number(fp.carryInterest)) - Number(fp.carryDistribution), disabled: true }),
      netIrrAfterCarry: new FormControl<number>(fp.netIrrAfterCarry === null ? null : Number((fp.netIrrAfterCarry * 100).toFixed(4)),
        { updateOn: 'change' }),
      mgmFees: new FormControl<number>(fp.mgmFees ? fp.mgmFees : null),
      totalExpenses: new FormControl<number>(fp.totalExpenses),
      aggregatedOrgExpenses: new FormControl<number>(fp.aggregatedOrgExpenses ? fp.aggregatedOrgExpenses : null),
      blocked: new FormControl<boolean>(fp.blocked),
      isVisible: new FormControl<boolean>(fp.isVisible),
      isBasedOnPrognosis: new FormControl<boolean>(fp.isBasedOnPrognosis),
      expectedFutureInv: new FormControl<number>(fp.expectedFutureInv),
      expectedOpEx: new FormControl<number>(fp.expectedOpEx),
      isTotalExpensesPositive: new FormControl<boolean>(fp.isTotalExpensesPositive),
      partnersCapital: new FormControl<number>({ value: undefined, disabled: true }),
      portfolioGain: new FormControl<number>({ value: undefined, disabled: true }),
      otherExpenses: new FormControl<number>({ value: undefined, disabled: true }),
      netGainBeforeCarry: new FormControl<number>({ value: undefined, disabled: true }),
      navAndDistributionBeforeCarry: new FormControl<number>({ value: undefined, disabled: true }),
      tvpiBeforeCarry: new FormControl<number>({ value: undefined, disabled: true }),
      tvpiAfterCarry: new FormControl<number>({ value: undefined, disabled: true }),
      navAfterCarry: new FormControl<number>({ value: undefined, disabled: true }),
      netGainAfterCarry: new FormControl<number>({ value: undefined, disabled: true }),
      navAndDistributionAfterCarry: new FormControl<number>({ value: undefined, disabled: true }),
      irrCalculated: new FormControl<number>(
        { value: ValueUtils.isValuePresent(fp.irrCalculated) ? (fp.irrCalculated * 100) : fp.irrCalculated, disabled: true }),
      irrCalculatedAfterCarry: new FormControl<number>(
        {
          value: ValueUtils.isValuePresent(fp.irrCalculatedAfterCarry) ? (fp.irrCalculatedAfterCarry * 100) : fp.irrCalculatedAfterCarry,
          disabled: true,
        }),
      totalExpIcon: new FormControl<string>(null),
      totalExpToolTip: new FormControl<string>(null),
      tvpiBeforeCarryIcon: new FormControl<string>(null),
      tvpiAfterCarryIcon: new FormControl<string>(null),
    });
    return form as FundPerformanceFormGroup;
  }
}
